import classNames from "classnames";

export const header = classNames([
    /* Tablet */
    "tablet:p-12",
    "tablet:bg-[url(/assets/images/backgrounds/media/desktop-header-x.svg)]",
    "tablet:bg-[position:calc(100%_-_1rem)_1rem]",
    /* All */
    "p-5",
    "bg-[url(/assets/images/backgrounds/media/mobile-header-x.svg)]",
    "bg-no-repeat",
    "bg-[position:5px_-60px]"
])

export const subHeading = classNames([
    /* Tablet */
    "tablet:text-2xl",
    "tablet:max-w-[700px]",
    /* All */
    "max-w-[70%]",
    "m-auto",
    "text-secondary",
    "text-xl",
    "text-center",
    "mt-8",
])